export default "__VITE_ASSET__ed2ceea6__"